import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-languages',
  templateUrl: './other-languages.component.html',
  styleUrls: ['./other-languages.component.scss']
})
export class OtherLanguagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
